import IReferralPartner from './IReferralPartner';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function parseReferralPartner(raw: any): IReferralPartner {
    return {
        abn: raw.abn,
        acl: raw.acl,
        aggregatorUuid: raw.aggregatorUuid,
        banned: raw.banned,
        chargesFee: raw.chargesFee,
        companyName: raw.companyName,
        conductsBusinessInPerson: raw.conductsBusinessInPerson,
        disclosesBenefits: raw.disclosesBenefits,
        email: raw.email,
        firstName: raw.firstName,
        groupName: raw.groupName,
        includesCustomerInfo: raw.includesCustomerInfo,
        lastName: raw.lastName,
        linkedInUrl: raw.linkedInUrl,
        nccp: raw.nccp,
        phone: raw.phone,
        postcode: raw.postcode,
        refersClient: raw.refersClient,
        state: raw.state,
        streetAddress: raw.streetAddress,
        suburb: raw.suburb,
        type: raw.type,
        uuid: raw.uuid,
    };
}
